var React = require('react');

function Vburger (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"Icon/Menu/Grey"),React.createElement("path",{"d":"M.5.5h18v1H.5zm0 12h18v1H.5zm0-6h18v1H.5z","fill":"#D8D8D8","stroke":"#979797","fillRule":"evenodd","key":1})]);
}

Vburger.defaultProps = {"width":"19","height":"14","viewBox":"0 0 19 14"};

module.exports = Vburger;

Vburger.default = Vburger;
